import { useCartMutationVariables } from "@/core/api/graphql/cart/composables";
import { useMutation } from "@/core/api/graphql/composables";
import { CalculateUsdSalesTaxDocument } from "@/core/api/graphql/types";
import type { CartIdFragment, CartExtension, InputCalculateUsdTaxType } from "@/core/api/graphql/types";
import type { MaybeRef } from "vue";

export function useCalculateUsdSalesTaxMutation(cart?: MaybeRef<CartIdFragment | undefined>) {
  return useMutation(CalculateUsdSalesTaxDocument, useCartMutationVariables(cart));
}

/** @deprecated Use {@link useCalculateUsdSalesTaxMutation} instead. */
export async function calculateUsdSalesTax(command: InputCalculateUsdTaxType): Promise<CartExtension> {
  const { mutate } = useCalculateUsdSalesTaxMutation();
  const result = await mutate({ command });
  return result!.data! as CartExtension;
}
